import ScalarIconShareNetwork_vue_vue_type_script_setup_true_lang_default from "./ScalarIconShareNetwork.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarIconShareNetwork.vue
var ScalarIconShareNetwork_default = ScalarIconShareNetwork_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconShareNetwork_default as default };

//# sourceMappingURL=ScalarIconShareNetwork.js.map